import { render, staticRenderFns } from "./SpotlightSuccessComponent.vue?vue&type=template&id=78a89c05&"
import script from "./SpotlightSuccessComponent.vue?vue&type=script&lang=js&"
export * from "./SpotlightSuccessComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports